// extracted by mini-css-extract-plugin
export default {"melodyVideo":"rP-z","isFullWidth":"sP-z","landingPageVideo":"tP-z","play":"uP-z","iframeVideo":"vP-z","playHidden":"wP-z","fullwidth":"xP-z"};